// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DpRytJ {
  display: flex;
  align-items: center;
  gap: 4px;
}

.e_7tUv {
  display: flex;
  align-items: center;
  gap: 4px;
}

.DetL1t {
  font-family: var(--breadcrumb-font-family);
  font-weight: var(--breadcrumb-font-weight);
  font-size: var(--breadcrumb-font-size);
  line-height: var(--breadcrumb-line-height);
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: color 0.2s ease;
}

.DetL1t:hover {
  opacity: 0.8;
}

.DetL1t.hMMnLw {
  cursor: default;
  color: var(--breadcrumb-current-color);
}

.DetL1t.eLdLWL {
  color: var(--breadcrumb-initial-color);
}

.DetL1t.PtQqDM {
  color: var(--breadcrumb-intermediate-color);
}

.aFUfl4 {
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -1px;
}

.aFUfl4.eLdLWL {
  filter: var(
    --breadcrumb-initial-filter,
    brightness(0) saturate(100%) invert(30%) sepia(96%) saturate(1823%) hue-rotate(352deg) brightness(101%)
      contrast(98%)
  );
}

.aFUfl4.PtQqDM {
  filter: var(--breadcrumb-intermediate-filter, invert(0) brightness(0.4));
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Breadcrumb/Breadcrumb.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,sCAAsC;EACtC,0CAA0C;EAC1C,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,wEAAwE;AAC1E","sourcesContent":[".breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.itemWrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.breadcrumbItem {\n  font-family: var(--breadcrumb-font-family);\n  font-weight: var(--breadcrumb-font-weight);\n  font-size: var(--breadcrumb-font-size);\n  line-height: var(--breadcrumb-line-height);\n  text-decoration: none;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.breadcrumbItem:hover {\n  opacity: 0.8;\n}\n\n.breadcrumbItem.current {\n  cursor: default;\n  color: var(--breadcrumb-current-color);\n}\n\n.breadcrumbItem.initial {\n  color: var(--breadcrumb-initial-color);\n}\n\n.breadcrumbItem.intermediate {\n  color: var(--breadcrumb-intermediate-color);\n}\n\n.separator {\n  width: 12px;\n  height: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -1px;\n}\n\n.separator.initial {\n  filter: var(\n    --breadcrumb-initial-filter,\n    brightness(0) saturate(100%) invert(30%) sepia(96%) saturate(1823%) hue-rotate(352deg) brightness(101%)\n      contrast(98%)\n  );\n}\n\n.separator.intermediate {\n  filter: var(--breadcrumb-intermediate-filter, invert(0) brightness(0.4));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumb": `DpRytJ`,
	"itemWrapper": `e_7tUv`,
	"breadcrumbItem": `DetL1t`,
	"current": `hMMnLw`,
	"initial": `eLdLWL`,
	"intermediate": `PtQqDM`,
	"separator": `aFUfl4`
};
module.exports = ___CSS_LOADER_EXPORT___;
